import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_VALIDATION_RESULTS_REQUEST = 'GET_VALIDATION_RESULTS_REQUEST';
export const GET_VALIDATION_RESULTS_SUCCESS = 'GET_VALIDATION_RESULTS_SUCCESS';
export const GET_VALIDATION_RESULTS_FAILURE = 'GET_VALIDATION_RESULTS_FAILURE';

function requestGetValidationResults() {
  return {
    type: GET_VALIDATION_RESULTS_REQUEST,
    isGettingReporting: true
  };
}

function receiveGetValidationResults(reportingResponse) {
  return {
    type: GET_VALIDATION_RESULTS_SUCCESS,
    isGettingReporting: false,
    reportingResponse,
    reportingError: null
  };
}

function rejectGetValidationResults(reportingError) {
  return {
    type: GET_VALIDATION_RESULTS_FAILURE,
    isGettingReporting: false,
    reportingError
  };
}

export function getValidationResults(pageNumber, pageSize, sortBy, sortDirection, filters, activeTab) {
  return (dispatch) => {
    dispatch(requestGetValidationResults());

    const promise = () => ApiService
      .getValidationResults(pageNumber, pageSize, sortBy, sortDirection, filters, activeTab)
      .then((response) => {
        dispatch(receiveGetValidationResults(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetValidationResults, true));
        }
      });
    return promise();
  };
}
